import React from "react"
import Layout from "../../components/global/Layout"
import Seo from "../../components/global/SEO"
import Nav from "../../components/global/DesktopNav"
import Footer from "../../components/global/Footer"
import ParticleHeader from "../../components/blocks/ParticleHeader"
import styled from "@emotion/styled"

const Outer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  row-gap: 32px;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  padding: 32px 0;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "#ffffff"};
`
const Inner = styled.div`
  width: 100%;
  grid-column: 2;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
  }
`

export default function TermsCons(props) {
  return (
    <Layout>
      <Seo title="Terms & Conditions" />
      <Nav />
      <ParticleHeader>Terms &amp; Conditions</ParticleHeader>
      <Outer>
        <Inner>
          <p>
            <strong>TERMS AND CONDITIONS</strong>
          </p>
          <p>
            <strong>Important Terms</strong>
          </p>
          <p>
            This page tells you the terms of use on which you may make use of
            our website, <a href="http://www.develrx.com">www.develrx.com</a> as
            a guest.  Please read these terms of use carefully before you start
            to use the website.  By using our website, you indicate that you
            accept these terms of use and that you agree to abide by them.  If
            you do not agree to these terms of use, please refrain from using
            our website.
          </p>
          <p>
            <strong>1.  DEFINITIONS</strong>
          </p>
          <p>
            In these Website Usage Terms (“Terms”) the following words shall
            have the corresponding meanings:-
          </p>
          <p>
            (a) “Affiliate” means any company, any subsidiary of that company,
            holding company of that company, or subsidiary of that holding
            company, and the terms “holding company” and “subsidiary” have the
            meanings given in Section 1159 of the Companies Act 2006;
          </p>
          <p>
            (b) “Content” means all content on our Website from time to time,
            which includes without limitation, all commentary, data, databases,
            program code, information, documents, logos, graphics, sounds and
            images;
          </p>
          <p>
            (c) “DevelRx”, “we”, “us”, and “our” mean DevelRx, a company
            registered in England and Wales with Company Registration Number
            12028847 and Registered Office at The Discovery Building, BioCity,
            Pennyfoot Street, Nottingham, NG1 1GF;
          </p>
          <p>
            (d) “you” or “your” means the person (including individuals, firms
            and companies and other organisations) browsing or using our
            Website; and(e) “Website” means{" "}
            <a href="http://www.develrx.com">www.develrx.com</a>.
          </p>
          <p>
            <strong>2.  OUR WEBSITE</strong>
          </p>
          <p>
            <strong>2.1  Ownership</strong>
          </p>
          <p>
            Our Website and its Content are owned and operated by DevelRx, and
            DevelRx retains all right, title and interest in and to the Website
            and the Content including all copyright, design rights and trade
            mark rights whether registered or unregistered and all other
            intellectual property and proprietary rights anywhere in the world
            in or to the Website and the Content.  Except for the license set
            out in Clause 2.2 below, DevelRx grants no licence and transfers no
            rights or interest in relation to the Website or Content and all
            rights in the Website and Content are reserved to DevelRx
            absolutely. Any goodwill in the Website shall accrue to the benefit
            of DevelRx.
          </p>
          <p>
            <strong>2.2  Use of Content</strong>
          </p>
          <p>
            DevelRx licenses you to download the Content into your browser, to
            store copies of the Content in your browser cache, and to make
            electronic or printed copies of the Content, solely for the purposes
            of browsing our Website, provided that: (1) any copyright or other
            proprietary notices of DevelRx within the Content are not deleted,
            modified or obscured and are reproduced on all copies of the
            Content; (2) such use and display is solely for your personal or
            internal use (that is, not for commercial gain and not distributed
            or otherwise transmitted outside of your home or business, or
            otherwise broadcast in any media); and (3) the Content is not
            reproduced, modified, edited, altered or enhanced in any manner; and
            (4) no part of our Website or Content may be reproduced or stored on
            any other website or included in any public or private electronic
            system or service without DevelRx’s prior written consent. Except as
            expressly permitted above by this Clause 2.2, any and all use,
            downloading, copying, publishing, transmitting, or distribution of
            the Content or any part of the Content is prohibited.  If you breach
            any of these Terms, your license to use our Content under this
            Clause 2.2, and your permission to use our Website automatically
            terminates and you must destroy and/or permanently erase any
            downloaded or printed Content and all extracts.
          </p>
          <p>
            <strong>2.3  No Unlawful or Prohibited Use</strong>
          </p>
          <p>
            You will not use our Website in any manner that could damage,
            disable, overburden, disrupt or impair any DevelRx server or any
            servers or networks used with our Website or interfere with use of
            any part of our Website by any other person or entity. You may not
            attempt to gain unauthorised access to any Content, other accounts,
            or computer systems connected to any DevelRx server through hacking,
            password mining or any other means. You may not obtain or attempt to
            obtain any Content through any means not intentionally made
            available through our Website. Further, you will not use our Website
            to violate any applicable law, regulation, contract or policy.
          </p>
          <p>
            <strong>2.4  Website Availability</strong>
          </p>
          <p>
            Our Website can be accessed from any countries around the world and
            may contain references to DevelRx services, programs and products
            that are not offered in your country. You acknowledge and agree that
            any such references do not constitute any obligation of DevelRx to
            offer such services, programs, or products in your country at any
            time. DevelRx makes no representation that information on our
            Website is appropriate or available for use in all countries and
            prohibits accessing materials from territories where the Content is
            illegal. Those who access our Website do so on their own initiative
            and of their own risk and are responsible for compliance with all
            applicable laws.  We will not be liable if our Website is
            unavailable at any time for any period.
          </p>
          <p>
            <strong>2.5  Third-Party Websites</strong>
          </p>
          <p>
            Our Website may contain links to third-party websites, which are not
            under the control of DevelRx. Please note that these links are for
            your convenience only. When you click on these links you are moving
            to another website. DevelRx does not endorse nor does it make any
            representation about third-party websites which are linked from our
            Website, nor any material posted on such third-party websites. When
            you access a third-party website, you do so at your own risk.
          </p>
          <p>
            <strong>2.6  Accuracy of Content</strong>
          </p>
          <p>
            We make all reasonable efforts to ensure that the information on our
            Website is accurate, complete and up to date at the time of your
            visit. However, there may be errors which we have failed to notice.
            We have the right to correct these errors and to cancel any orders
            or contracts made on the basis of these errors, without liability to
            you.  The Content is provided without any guarantee, conditions or
            warranties as to its accuracy and we hereby expressly exclude, to
            the extent permitted by law, all conditions, warranties and other
            terms which might otherwise be implied by statute, common law or the
            law of equity.
          </p>
          <p>
            <strong>2.7  Termination of Use</strong>
          </p>
          <p>
            DevelRx may, in its sole discretion and without notice to you,
            terminate your use of or access to our Website at any time. DevelRx
            will normally do so if DevelRx believes that you have violated these
            Terms or any applicable law or regulation or that you have engaged
            in conduct that DevelRx determines in its sole discretion to be
            inappropriate.
          </p>
          <p>
            <strong>2.8  Indemnity for your Misuse</strong>
          </p>
          <p>
            You agree to indemnify, defend and hold DevelRx (and its Affiliates,
            directors, officers, employees, shareholders, agents and partners)
            harmless from any and all claims, damages, liabilities, costs and
            expenses (including reasonable attorneys’ fees) arising out of: (a)
            your use or misuse of our Website or any Content; (b) your breach or
            alleged breach of any of these Terms; or (c) your violation of any
            law, rule, regulation or rights of others.
          </p>
          <p>
            <strong>3.  OUR LIABILITY TO YOU</strong>
          </p>
          <p>
            <strong>3.1  Liability Not Excluded or Limited</strong>
          </p>
          <p>
            We do not limit or exclude our liability to you: (a) for death or
            personal injury caused by our negligence; (b) for fraud or
            fraudulent misrepresentation; or (c) under the Data Protection Act
            1998 or the Privacy and Electronic Communications (EC Directive)
            Regulations 2003; or (d) any liability to the extent that such
            liability may not be limited or excluded by law.
          </p>
          <p>
            <strong>3.2  Use of Website and Content</strong>
          </p>
          <p>
            You use our Website and its Content at your own risk, and we assume
            no duty of care to you and accept no liability whatsoever (including
            for negligence) to you with respect to our Website or the Content or
            any loss or damage you suffer arising from your use of or reliance
            on the same.
          </p>
          <p>
            <strong>3.3 Exclusion of Liability</strong>
          </p>
          <p>(a) Excluded Types of Loss</p>
          <p>
            If you are not an individual  (e.g. you are a company, corporate
            entity, partnership, firm, government authority, or other
            organisation), then, subject to Clause 3.1 above, we shall have no
            liability to you for: loss of revenue, bargain, profit, contract,
            business, use (including use of money), production, reputation,
            fines or goodwill; any loss or damage related to business
            interruption; any loss, damage or corruption to your data or any
            computer system or attributable to your failure to make and retain
            reasonable back-ups of your data and computer systems; any special,
            indirect, punitive, incidental or consequential loss or damage; your
            liability to any third party; or any loss or damage suffered by any
            third party; any loss or damage resulting from your misuse of our
            Website or Content; in each case whether or not we have been advised
            of or have knowledge of the likelihood of your suffering the same.
          </p>
          <p>(b) Reliance on Information Posted</p>
          <p>
            Content posted on our Website is not intended to amount to advice on
            which reliance should be placed.  We therefore disclaim all
            liability and responsibility arising from any reliance placed on any
            Content by any visitor to our Website or by anyone who may be
            informed of any of its Content.
          </p>
          <p>
            <strong>3.4  Meaning of Liability</strong>
          </p>
          <p>
            References in these Terms to our liability are to our liability
            under or in connection with our Website and the Content, including
            (without limitation) liability (whether contractual or
            non-contractual) for breach of contract, negligence, breach of
            statutory duty, accidental or negligent misrepresentation, strict
            liability or any other liability we may have to you whatsoever and
            howsoever arising under any other legal or equitable theory.
          </p>
          <p>
            <strong>4. GENERAL</strong>
          </p>
          <p>
            <strong>4.1  Law and Jurisdiction</strong>
          </p>
          <p>
            These Terms and all matters relating to your access to or use of our
            Website, and all contractual and non-contractual claims and disputes
            arising under or in connection with the same, shall be governed by
            the laws of England and Wales, and you hereby submit to the
            exclusive jurisdiction of the English and Welsh courts.
          </p>
          <p>
            <strong>4.2  Changes to these Terms</strong>
          </p>
          <p>
            We may change these terms at any time by posting a revised version
            to our Website.  If you continue to use our Website after the
            change, you are indicating that you accept the revised terms.
          </p>
        </Inner>
      </Outer>
      <Footer />
    </Layout>
  )
}
